










import { MountingPortal } from 'portal-vue'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
    MountingPortal
  }
})
export default class FullscreenModal extends Vue {
  @Prop({ required: false, default: true }) showNavigation!: boolean
  mounted () {
    document.body.classList.add('modal-open')
  }

  destroyed () {
    document.body.classList.remove('modal-open')
  }
}
